export default __webpack_public_path__ + "static/media/hummus_with_garlic.6370e56a.jpg";